import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useAppHeaderDocumentDetails } from "./AppHeader.hooks";

export const AppHeader = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editAppHeader,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useAppHeaderDocumentDetails(query.get("editId") || "");

  const {
    data: editAppHeaderById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    const activeTab = query.get("activeTab");
    if (activeTab === "appHeader") {
      refetchCategories();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("activeTab"), query.get("editId"), query.get("id")]);

  const [currentAirport] = useLocalStorage("currentAirport", null);

  const formConfig: FormConfig = {
    initialValues: {
      Image: editAppHeaderById?.payload
        ? [
            {
              uid: "-1",
              name: "Image.png",
              status: "done",
              url: editAppHeaderById?.payload?.Image,
            },
          ]
        : editAppHeader?.Image
          ? [
              {
                uid: "-1",
                name: "Image.png",
                status: "done",
                url: editAppHeader?.Image,
              },
            ]
          : "",

      androidQrImage: editAppHeaderById?.payload
        ? [
            {
              uid: "-1",
              name: "androidQrImage.png",
              status: "done",
              url: editAppHeaderById?.payload?.androidQrImage,
            },
          ]
        : editAppHeader?.androidQrImage
          ? [
              {
                uid: "-1",
                name: "androidQrImage.png",
                status: "done",
                url: editAppHeader?.androidQrImage,
              },
            ]
          : "",

      iosQrImage: editAppHeaderById?.payload
        ? [
            {
              uid: "-1",
              name: "iosQrImage.png",
              status: "done",
              url: editAppHeaderById?.payload?.iosQrImage,
            },
          ]
        : editAppHeader?.iosQrImage
          ? [
              {
                uid: "-1",
                name: "iosQrImage.png",
                status: "done",
                url: editAppHeader?.iosQrImage,
              },
            ]
          : "",

      welcomeText: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.welcomeText)
        : editAppHeader
          ? decodeHTML(editAppHeader?.welcomeText)
          : "",

      welcome_text_ms: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.welcome_text_ms)
        : editAppHeader
          ? decodeHTML(editAppHeader?.welcome_text_ms)
          : "",

      welcome_text_zh: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.welcome_text_zh)
        : editAppHeader
          ? decodeHTML(editAppHeader?.welcome_text_zh)
          : "",

      sub_text_ms: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.sub_text_ms)
        : editAppHeader
          ? decodeHTML(editAppHeader?.sub_text_ms)
          : "",

      sub_text_zh: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.sub_text_zh)
        : editAppHeader
          ? decodeHTML(editAppHeader?.sub_text_zh)
          : "",

      androidTextMs: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.androidTextMs)
        : editAppHeader
          ? decodeHTML(editAppHeader?.androidTextMs)
          : "",

      androidTextZh: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.androidTextZh)
        : editAppHeader
          ? decodeHTML(editAppHeader?.androidTextZh)
          : "",

      iosTextMs: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.iosTextMs)
        : editAppHeader
          ? decodeHTML(editAppHeader?.iosTextMs)
          : "",

      iosTextZh: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.iosTextZh)
        : editAppHeader
          ? decodeHTML(editAppHeader?.iosTextZh)
          : "",

      subText: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.subText)
        : editAppHeader
          ? decodeHTML(editAppHeader?.subText)
          : "",
      androidText: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.androidText)
        : editAppHeader
          ? decodeHTML(editAppHeader?.androidText)
          : "",
      androidLink: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.androidLink)
        : editAppHeader
          ? decodeHTML(editAppHeader?.androidLink)
          : "",
      iosText: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.iosText)
        : editAppHeader
          ? decodeHTML(editAppHeader?.iosText)
          : "",
      iosLink: editAppHeaderById
        ? decodeHTML(editAppHeaderById.payload?.iosLink)
        : editAppHeader
          ? decodeHTML(editAppHeader?.iosLink)
          : "",
    },
    fields: fields.appHeader,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["Image", "androidQrImage", "iosQrImage"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (Array.isArray(field)) {
          if (field.length === 0) {
            data[key] = "";
            continue;
          }
          const first = field[0];

          if (first?.originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", first.originFileObj);
            formData.append("application", "PASSENGER");
            const res: any = await post("management/upload-file", formData);
            if (res) data[key] = res.response.data;
            else data[key] = "";
            continue;
          }

          if (typeof first?.url === "string") {
            if (first.url.trim() === "") {
              data[key] = "";
            } else {
              data[key] = first.url;
            }
            continue;
          }
          data[key] = "";
        } else {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
        data[key] = "";
      }
    }

    const payload = {
      action,
      method,
      module: "Mobile App",
      subModule: "appHeader",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: editAppHeader?.id || editAppHeaderById?.payload?.id,
        }),
        ...data,
        airport: currentAirport,
        published: true,
      },
      status,
    };

    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${passengerHost}/api/get-mobile-app-header/${editAppHeader?.id || editAppHeaderById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Mobile App"
      />
    </>
  );
};
